import { UploadOutlined } from "@mui/icons-material";
import LoadingAnimation from "../../componets/loader/loader";
import { API } from "../../config/api";
import { DELETE, GET, POST } from "../../utils/apicalls";
import { Button, Card, Form, Input, Modal, notification, Select, Space, Table, Upload } from "antd";
import AWS from "aws-sdk";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";



function Clientproduct() {
  const user = useSelector((state: any) => state.user);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [meta, setMeta] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryData, setCategoryData] = useState<any>([]);
  const [ProductData, setProductData] = useState<any>([]);
  const [Productfilter, setProductfilterData] = useState<any>([]);
  const navigate = useNavigate();
  const [subcategoryData, setsubCategoryData] = useState<any>([]);
  interface AwsData {
    accessKeyId?: string;
    secretAccessKey?: string;
    region?: string;
    [key: string]: any;
  }
  const [awsData, setawsData] = useState<AwsData>({});
  const s3 = new AWS.S3({
    accessKeyId: awsData.accessKeyId,
    secretAccessKey: awsData.secretAccessKey,
    region: awsData.region,
  });
  const fetchawsDetails = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
      if (response && response.accessKeyId) {
        setawsData(response); // Not response.data
      } else if (response?.data?.accessKeyId) {
        setawsData(response.data); // If using Axios-style
      } else {
        console.warn("AWS credentials not found in response", response);
      }
    } catch (error) {
      console.error("Failed to fetch AWS credentials", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
      AWS.config.update({
        accessKeyId: awsData.accessKeyId,
        secretAccessKey: awsData.secretAccessKey,
        region: awsData.region,
      });
    }
  }, [awsData]);
  useEffect(() => {
    fetchawsDetails();
  }, []); const S3_BUCKET = awsData?.bucketName;

  // FIXED: Use only one state management system
  const [productImages, setProductImages] = useState({
    productImage1: '',
    productImage2: '',
    productImage3: '',
    productImage4: ''
  });

  // FIXED: Add upload status tracking
  const [uploadingImages, setUploadingImages] = useState({
    productImage1: false,
    productImage2: false,
    productImage3: false,
    productImage4: false
  });

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.LISTING_GET_CATEGORY, {});
      setCategoryData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchProductsGet = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.PRODUCT_GET_LISTING, {});
      setProductData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchProductsGet();
    fetchProducts(page, pageSize);
  }, [page, pageSize]);

  const uploadMultipleFiles = async (fileList: any[]) => {
    const availableFields = (['productImage1', 'productImage2', 'productImage3', 'productImage4'] as (keyof typeof productImages)[])
      .filter(field => !productImages[field]);

    if (fileList.length > availableFields.length) {
      notification.error({ message: `Can only upload ${availableFields.length} more images!` });
      return;
    }

    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      const fieldName = availableFields[i];

      // Set uploading state
      setUploadingImages(prev => ({ ...prev, [fieldName]: true }));

      const params = {
        Bucket: S3_BUCKET,
        Key: `product/${fieldName}/${Date.now()}_${file.name}`,
        Body: file,
        ContentType: file.type,
      };

      try {
        const data = await s3.upload(params).promise();

        setProductImages(prev => ({
          ...prev,
          [fieldName]: data.Location
        }));

        form.setFieldsValue({ [fieldName]: data.Location });
        notification.success({ message: `${file.name} uploaded successfully!` });
      } catch (err) {
        notification.error({ message: `Failed to upload ${file.name}!` });
      } finally {
        // Reset uploading state
        setUploadingImages(prev => ({ ...prev, [fieldName]: false }));
      }
    }
  };

  const fetchProducts = async (currentPage: number, currentPageSize: number) => {
    try {
      setIsLoading(true);
      const obj = {
        query: "query",
        page: currentPage,
        take: currentPageSize,
        clientId: user.id
      };

      const url = API.LIST_PRODUCT;
      const response: any = await POST(url, obj);

      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_customer_url = `${API.DELETE_PRODUCT}${id}`;
      const data: any = await DELETE(delete_customer_url);

      if (data.status) {
        notification.success({ message: "product deleted successfully!" });
        fetchProducts(page, pageSize);
      } else {
        notification.error({
          message: "Something went wrong! Please try again later.",
        });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = (id: any) => {
    const confirm = window.confirm("Are you sure you want to delete this ?");
    if (confirm) {
      handleDelete(id);
    }
  };

  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    { title: "productTitle", dataIndex: "productTitle" },
    {
      title: "productImage1",
      dataIndex: "productImage1",
      render: (url: string) => (
        url ? <img src={url} alt="productImage1" style={{ width: 100, height: 100 }} /> : 'No Image'
      ),
    },
    {
      title: "productImage2",
      dataIndex: "productImage2",
      render: (url: string) => (
        url ? <img src={url} alt="productImage2" style={{ width: 100, height: 100 }} /> : 'No Image'
      ),
    },
    {
      title: "productImage3",
      dataIndex: "productImage3",
      render: (url: string) => (
        url ? <img src={url} alt="productImage3" style={{ width: 100, height: 100 }} /> : 'No Image'
      ),
    },
    {
      title: "productImage4",
      dataIndex: "productImage4",
      render: (url: string) => (
        url ? <img src={url} alt="productImage4" style={{ width: 100, height: 100 }} /> : 'No Image'
      ),
    },
    { title: "descriptionProduct", dataIndex: "descriptionProduct" },
    // { title: "brand", dataIndex: "brand" },
    // { title: "shipping", dataIndex: "shipping" },
    // { title: "color", dataIndex: "color" },
    // { title: "gender", dataIndex: "gender" },
    // { title: "size", dataIndex: "size" },
    { title: "Price", dataIndex: "Price" },
    { title: "stock of product", dataIndex: "stock_product" },
    {
      title: "category",
      dataIndex: "category_id",
      render: (_: any, record: any) => (
        <span>{record?.categoryid?.categoryTitle}</span>
      ),
    },
    {
      title: " sub category",
      dataIndex: "Subcategory_id",
      render: (_: any, record: any) => (
        <span>{record?.subcategoryid?.SubcategoryTitle}</span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button type="link" onClick={() => confirmDelete(record.id)}>
            Delete
          </Button>
          <Button
            type="link"
            onClick={() =>
              navigate(`/client/clientProduct/updateproduct/${record.id}`)
            }
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  // FIXED: Updated submit handler to use productImages state
  const submitHandler = async (values: any) => {
    console.log('Form values before submission:', values); // Debug log
    console.log('Product images state:', productImages); // Debug log

    // Check if any images are still uploading
    const isUploading = Object.values(uploadingImages).some(uploading => uploading);
    if (isUploading) {
      notification.warning({
        message: "Please wait for all images to finish uploading before submitting."
      });
      return;
    }

    try {
      let obj = {
        productTitle: values.productTitle,
        productImage1: productImages.productImage1 || null,
        productImage2: productImages.productImage2 || null,
        productImage3: productImages.productImage3 || null,
        productImage4: productImages.productImage4 || null,
        descriptionProduct: values.descriptionProduct,
        brand: values.brand,
        color: values.color,
        gender: values.gender,
        size: values.size,
        shipping: values.shipping,
        Price: Number(values.Price),
        category_id: values.category_id,
        clientId: user.id,
        Subcategory_id: values.Subcategory_id,
      };



      setIsLoading(true);
      const postRequest: any = await POST(API.CREATE_PRODUCT, obj);
      if (postRequest.status && postRequest.data?.id) {
        const productId = postRequest.data.id;
        const variants = values.variants || [];

        // Step 3️⃣: Create variants one by one
        if (variants.length > 0) {
          for (const variant of variants) {
            const variantObj = {
              productId: productId,
              variantName: variant.variantName,
              variantprice: Number(variant.variantprice),
            };

            // ⚠️ Replace this API with your actual variant creation endpoint
            await POST(API.CREATE_PRODUCT_VARIANT, variantObj);
          }
        }

        // Step 4️⃣: Notify success
        notification.success({
          message: "Product and variants added successfully!",
        });

        // Step 5️⃣: Reset form and UI
        form.resetFields();

        // FIXED: Reset the productImages state
        setProductImages({
          productImage1: '',
          productImage2: '',
          productImage3: '',
          productImage4: ''
        });

        fetchCategories();
        fetchProducts(page, pageSize);
        setIsModalOpen(false);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const filtersubCategoryData = async (categoryId: number) => {
    try {
      setIsLoading(true);
      const api = API.FILTER_SUBCATEGORY;
      const response: any = await POST(api, { category_id: categoryId });

      if (response?.data) {
        setsubCategoryData(response?.data);
      } else {
        console.error("Data not available:", response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="banner-container">
        {isLoading ? (
          <LoadingAnimation />
        ) : (
          <div className="banner-content">
            <h1 className="banner-title">Product Management</h1>
            <button
              className="banner-button"
              onClick={() => setIsModalOpen(true)}
            >
              Create Product
            </button>
          </div>
        )}
      </div>



      <Card>
        <Table
          columns={columns}
          dataSource={Productfilter.length ? Productfilter : data}
          loading={isLoading}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total,
            showSizeChanger: true,
            onChange: (newPage, newPageSize) => {
              setPage(newPage);
              setPageSize(newPageSize);
              fetchProducts(newPage, newPageSize);
            },
          }}
          rowKey={(record: any) => record.id}
          scroll={{ x: "max-content" }}
        />
      </Card>

      <Modal
        title="Add Product"
        visible={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          // Reset form and images when closing modal
          form.resetFields();
          setProductImages({
            productImage1: '',
            productImage2: '',
            productImage3: '',
            productImage4: ''
          });
        }}
        footer={null}
        width="50%"
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="productTitle"
                label="Product Title"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="brand" label="Brand">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="shipping" label="shipping">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="color" label="Color">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="size" label="Size">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="gender"
                label="Gender"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select Gender">
                  <Select.Option value="male">Male</Select.Option>
                  <Select.Option value="female">Female</Select.Option>
                  <Select.Option value="other">Other</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="Price"
                label="Price"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="category_id"
                label="Category"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Select a category"
                  onChange={(value) => {
                    form.setFieldsValue({ subCategory: undefined });
                    filtersubCategoryData(value);
                  }}
                  loading={isLoading}
                >
                  {categoryData?.map((category: any) => (
                    <Select.Option key={category.id} value={category.id}>
                      {category.categoryTitle}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="Subcategory_id"
                label="SubCategory"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select a subcategory" loading={isLoading}>
                  {subcategoryData?.map((sub: any) => (
                    <Select.Option key={sub.id} value={sub.id}>
                      {sub.SubcategoryTitle}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="descriptionProduct"
                label="Description"
                rules={[{ required: true }]}
              >
                <Input.TextArea autoSize={{ minRows: 3, maxRows: 8 }} />
              </Form.Item>
            </Col>
          </Row>

          {/* FIXED: Multiple image upload section */}
          <Form.Item label="Product Images">
            <Upload
              multiple
              maxCount={4}
              listType="picture-card"
              fileList={[]}
              beforeUpload={(file, fileList) => {
                uploadMultipleFiles(fileList);
                return false;
              }}
              showUploadList={false}
            >
              {Object.values(productImages).filter(Boolean).length < 4 && (
                <div>
                  <UploadOutlined />
                  <div style={{ marginTop: 8 }}>
                    Upload Images ({Object.values(productImages).filter(Boolean).length}/4)
                  </div>
                </div>
              )}
            </Upload>

            {/* Custom preview grid */}
            <div style={{ marginTop: 16 }}>
              <Row gutter={[8, 8]}>
                {Object.entries(productImages).map(([key, url]) => (
                  url && (
                    <Col span={6} key={key}>
                      <div style={{ position: 'relative' }}>
                        <img
                          src={url}
                          alt={`Product ${key}`}
                          style={{
                            width: "100%",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "6px",
                            border: "1px solid #d9d9d9"
                          }}
                        />
                        <Button
                          type="text"
                          danger
                          size="small"
                          style={{
                            position: 'absolute',
                            top: '2px',
                            right: '2px',
                            background: 'rgba(255,255,255,0.9)',
                            minWidth: '20px',
                            height: '20px',
                            padding: 0
                          }}
                          onClick={() => {
                            setProductImages(prev => ({ ...prev, [key]: '' }));
                            form.setFieldsValue({ [key]: '' });
                          }}
                        >
                          ×
                        </Button>
                      </div>
                    </Col>
                  )
                ))}
              </Row>
            </div>
          </Form.Item>

          <Form.List name="variants">
            {(fields, { add, remove }) => (
              <>
                <h4>Product Variants</h4>
                {fields.map(({ key, name, ...restField }) => (
                  <Row gutter={16} key={key}>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, "variantName"]}
                        label="Variant Name"
                        rules={[{ required: true, message: "Enter variant name" }]}
                      >
                        <Input placeholder="e.g. XL or 1kg" />
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, "variantprice"]}
                        label="Variant Price"
                        rules={[{ required: true, message: "Enter price" }]}
                      >
                        <Input type="number" placeholder="Price" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Button danger onClick={() => remove(name)}>Remove</Button>
                    </Col>
                  </Row>
                ))}

                <Button type="dashed" onClick={() => add()} block>
                  + Add Variant
                </Button>
              </>
            )}
          </Form.List>

          <Button
            type="primary"
            htmlType="submit"
            block
            loading={Object.values(uploadingImages).some(uploading => uploading)}
            disabled={Object.values(uploadingImages).some(uploading => uploading)}
          >
            {Object.values(uploadingImages).some(uploading => uploading)
              ? 'Uploading Images...'
              : 'Submit'
            }
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default Clientproduct;